import { Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractTemplateListingComponent } from '../templates/template-listing/abstract-template-listing.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-signable-eform',
  templateUrl: './signable-eform.component.html',
  styleUrl: './signable-eform.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SignableEformComponent extends AbstractTemplateListingComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = 'todo-application';
  private templateFilters: Subscription;
  /**
     * Lifecycle hook that is called after data-bound properties of a directive are initialized.
     * 
     * This method gets the query string from the route state and sets it to the `search` property.
     * If the query string is not empty, it calls the `getTemplates` method with the query string.
     * If the query string is empty, it calls the `getTemplates` method without any arguments.
     * It also subscribes to the `templateFilters` observable to get the template filters.
     * 
     * @returns {void}
     */
  ngOnInit(): void {
    const query = history.state?.query ?? '';
    this.search = query;
    if (query) {
      this.getTemplates(1, query);
    } else {
      this.getTemplates();
    }
    this.templateFilters = this.templateService.onGetFilters().subscribe(filter => {
      this.filters = filter.filters;
      this.getTemplates();
    });
  }
  /**
     * Lifecycle hook that is called when the component is destroyed.
     * Unsubscribes from the `templateFilters` observable to prevent memory leaks.
     */
  ngOnDestroy(): void {
    if (this.templateFilters) {
      this.templateFilters.unsubscribe();
    }
  }
}
